const my_profile = {
  viewMyClubSeacretProfile: "عرض ملفي الشخصي في ClubSeacret", // translated
  viewMoreDetails: "عرض المزيد من التفاصيل", // translated
  verifiedEmail: "بريد إلكتروني تم التحقق منه", // translated
  unverifiedEmail: "البريد الإلكتروني لم يتم التحقق منها", // translated
  balance: "توازن", // translated
  pointsIn: "النقاط في", // translated
  pointsOut: "يشير الى", // translated
  topUp: "فوق حتى", // translated
  pointsHistoryTable: "جدول تاريخ النقاط", // translated
  createdFrom: "تم الإنشاء من", // translated
  createdTo: "تم الإنشاء إلى", // translated
  selectStatus: "اختر الحالة...", // translated
  searchByTitle: "البحث حسب العنوان...", // translated
  pushNotifications: "خطة التأمين", // translated 
  pushNotificationsDescription: "إشعارات المتصفح للتحديثات والأحداث المهمة", // translated 
  pushNotificationsNotSupported: "إشعارات الدفع غير مدعومة في هذا الإصدار", // translated 
  pushNotificationsDeniedMessage: "تم رفض الإخطارات. يرجى استخدام التنبيهات في إعدادات الإصدارات ثم إشعارات الدفع.", // translated 
  pushNotificationsEnabled: "طفح جلدي فعال", // translated 
  pushNotificationsDisabled: "تم الدفع بشكل فعال", // translated 
  userInformationMissing: "المعلومات المستخدمة مفقودة", // translated 
  failedToUpdatePushNotifications: "فشل تحديث إعدادات إشعارات الدفع", // translated 
  notificationPermissionDenied: "تم رفض الإخطارات. يرجى الاطلاع على إعدادات المتصفح.", // translated 
  notificationPermissionRequired: "إذن إذن مطلوب إشعارات الدفع", // translated 
  notSupported: "غيرانري", // translated 
  permissionDenied: "تمبرو إنفاس", // translated 
  permissionNotRequested: "دون مزيد من مساحة المنتزه", // translated 
  enabled: "مخلص", // translated 
  disabled: "مع طاف", // translated 
};


export default my_profile;
